<template>
  <div class="campaign">
    <div class="d-flex justify-space-between align-center mb-4">
      <h4>Favourite Influencers</h4>
    </div>

    <v-tabs
      v-model="tab"
      @change="getFavList()"
      grow
    >
      <v-tab>YouTube</v-tab>
      <v-tab>Instagram</v-tab>
    </v-tabs>

    <v-progress-linear
      class="my-4"
      indeterminate
      color="primary"
      v-if="loading"
    ></v-progress-linear>

    <div v-if="this.params.type === 1">
      <v-simple-table
        class="mt-4 mb-4"
        fixed-header
        v-if="favList.length > 0"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Channel</th>
              <!-- <th class="text-center">Channel Name</th> -->
              <!-- <th class="text-center">Channel LInk</th> -->
              <th class="text-center">Language</th>
              <!-- <th class="text-center">Category</th> -->
              <th class="text-center">YouTube Category</th>
              <th class="text-center">Gender</th>
              <th class="text-center">Subscribers</th>
              <th class="text-center">Total View</th>
              <th class="text-center">Total Video</th>
              <th class="text-center">Avg View</th>
              <th class="text-center">Engagement Rate</th>
              <th class="text-center">Last Publish Date</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in favList"
              :key="item.channel_id"
            >
              <td class="channelMeta">
                <a
                  :href="item.channel_link"
                  target="_blank"
                  class="d-flex align-center"
                >
                  <div>
                    <v-img
                      v-if="item.avatar"
                      :src="item.avatar"
                    ></v-img>
                    <!-- <div
                      class="team-image"
                      v-else
                    >
                      {{ item.channel_name ? item.channel_name.charAt(0) : 'NA' }}
                    </div> -->
                    <v-img
                      v-else
                      :src="`https://ui-avatars.com/api/?name=${item.channel_name}&background=F54153&color=FFF`"
                    ></v-img>
                  </div>
                  <p>
                    <strong>{{ item.channel_name }}</strong> <br>
                    <v-chip
                      v-if="item.category"
                      x-small
                      color="teal"
                      text-color="white"
                    >
                      {{ item.category }}
                    </v-chip>
                  </p>
                </a>
              </td>
              <!-- <td class="text-center">{{ item.channel_name }}</td>
              <td class="text-center"><a
                  v-bind:href="item.channel_link"
                  target="_blank"
                  class="nav-link"
                  style="color:blue;"
                > Channel Link
                </a></td> -->
              <td class="text-center">{{ item.language ? item.language : '-' }}</td>
              <!-- <td class="text-center">{{ item.category }}</td> -->
              <td class="text-center">{{ item.yt_category ? catName(item.yt_category) : '-'}}</td>
              <td class="text-center">{{ item.gender ? item.gender : '-' }}</td>
              <td class="text-center">{{ item.subscribers | formatNumber }}</td>
              <td class="text-center">{{ item.total_view | formatNumber }}</td>
              <td class="text-center">{{ item.total_video | formatNumber  }}</td>
              <td class="text-center">{{ item.latest_avg_view | formatNumber }}</td>
              <td class="text-center">{{ item.eng_rate ? item.eng_rate + '%' : '-'}}</td>
              <td>{{ item.last_video_date | dateFormat }}</td>
              <td class="text-center">
                <div class="d-flex align-center justify-center">
                  <img
                    src="@/assets/images/add.svg"
                    width="24"
                    class="mr-2"
                    style="cursor:pointer"
                    @click="openDialogCampaign(item.influencer_id)"
                  >
                  <v-icon
                    color="#F54153"
                    size="28"
                    @click="favDelete(item.id)"
                  >mdi-delete</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div v-else>
      <v-simple-table
        class="mt-4 mb-4"
        fixed-header
        v-if="favList.length > 0"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Channel</th>
              <!-- <th class="text-center">Instagram Name</th> -->
              <!-- <th class="text-center">Insta LInk</th> -->
              <th class="text-center">Language</th>
              <!-- <th class="text-center">Category</th> -->
              <th class="text-center">Gender</th>
              <th class="text-center">Followers</th>
              <th class="text-center">Total Media</th>
              <!-- <th class="text-center">Account Type</th> -->
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in favList"
              :key="item.insta_username"
            >
              <td class="channelMeta">
                <a
                  :href="item.insta_link"
                  target="_blank"
                  class="d-flex align-center"
                >
                  <div>
                    <v-badge
                      v-if="item.is_verify"
                      color="success"
                      icon="mdi-check"
                      avatar
                      bordered
                      overlap
                    >
                      <v-avatar size="45">
                        <v-img :src="`https://ui-avatars.com/api/?name=${item.insta_name}&background=F54153&color=FFF`"></v-img>
                      </v-avatar>
                    </v-badge>
                    <v-img
                      v-else
                      :src="`https://ui-avatars.com/api/?name=${item.insta_name}&background=F54153&color=FFF`"
                    ></v-img>
                  </div>
                  <p>
                    <strong>{{ item.insta_name }}</strong> <br>
                    <v-chip
                      v-if="item.category"
                      x-small
                      color="teal"
                      text-color="white"
                    >
                      {{ item.category }}
                    </v-chip>
                  </p>
                </a>
              </td>
              <!-- <td class="text-center">
                <a :href="item.insta_link" target="_blank">
                  <v-img
                    :src="`https://ui-avatars.com/api/?name=${item.insta_name}&background=F54153&color=FFF`"
                    width="60"
                    :aspect-ratio="16/16"
                  ></v-img>
                </a>
              </td> -->
              <!-- <td class="text-center">{{ item.insta_name }}</td> -->
              <!-- <td class="text-center"><a
                  v-bind:href="item.insta_link"
                  target="_blank"
                  class="nav-link"
                  style="color:blue;"
                > Channel Link
                </a></td> -->
              <td class="text-center">{{ item.language ? item.language : '-' }}</td>
              <td class="text-center">{{ item.gender ? item.gender : '-' }}</td>
              <td class="text-center">{{ item.followers | formatNumber  }}</td>
              <td class="text-center">{{ item.total_media | formatNumber }}</td>
              <!-- <td class="text-center">{{ item.is_business ? account(item.is_business) : '-'}}</td> -->
              <!-- <td class="text-center">{{ item.is_business | accountType }}</td> -->
              <td class="text-center">
                <div class="d-flex align-center justify-center">
                  <img
                    src="@/assets/images/add.svg"
                    width="24"
                    class="mr-2"
                    style="cursor:pointer"
                    @click="openDialogCampaign(item.influencer_id)"
                  >
                  <v-icon
                    color="#F54153"
                    size="28"
                    @click="favDelete(item.id)"
                  >mdi-delete</v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div
      class="text-center ma-8"
      v-if="!loading && favList.length <= 0"
    >
      <img
        src="@/assets/images/no-campaign.png"
        width="150"
      />
      <h3>No Influencers Found</h3>
      <v-btn
        depressed
        dark
        large
        color="primary"
        to="/influencer/list"
        style="width: 350px;"
      >Select and add influencers</v-btn>
    </div>

    <v-pagination
      v-model="params.page"
      :length="this.favCount"
      @input="getFavList()"
      :total-visible="10"
      v-if="!loading && this.favCount > 1"
    ></v-pagination>
    <v-dialog
      v-model="dialogCampaign"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>

        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>
            <!-- Your {{this.tab + 1 | platform}} -->
            <v-icon
              v-if="this.tab === 0"
              class="mr-2"
              color="#ff0101"
              x-large
            >mdi-youtube</v-icon>
            <v-icon
              v-else
              class="mr-2"
              color="#ff0101"
              x-large
            >mdi-instagram</v-icon>Progress Campaigns
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="dialogCampaign = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :loading="loadingCam"
          loading-text="Loading... Please wait"
          show-select
          :disable-sort="true"
          @item-selected="selectData"
          v-model="selected"
          :items="indexedItems"
          mobile-breakpoint="0"
          class="ma-4"
          hide-default-footer
        >
          <!-- @toggle-select-all="alldata" -->
          <!-- commented to remove select all row option -->
          <template v-slot:[`header.data-table-select`]>Selected</template>
          <!--  remove select all row option to title -->
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              v-if="item.status === 0"
              color="warning"
              small
            > Pending
            </v-chip>
            <v-chip
              v-if="item.status === 1"
              color="success"
              small
            > Approved
            </v-chip>
            <v-chip
              v-if="item.status === 2"
              color="error"
              small
            > Rejected
            </v-chip>
          </template> -->
          <template v-slot:[`item.campaign_type`]="{ item }">
            {{item.campaign_type | campaignType }}
          </template>
          <template v-slot:[`item.content_type`]="{ item }">
            <span v-if="item.promo_platform === 1">{{item.content_type | youtube}}</span>
            <span v-else>{{item.content_type | instagram}}</span>
          </template>
          <template v-slot:[`item.category`]="{ item }">
            <span
              v-for="category in item.category"
              :key="category"
            >{{ category }}, </span>
          </template>
          <template v-slot:[`item.language`]="{ item }">
            <span
              v-for="language in item.language"
              :key="language"
            >{{ language }}, </span>
          </template>
          <template v-slot:[`item.gender`]="{ item }">
            <span
              v-for="gender in item.gender"
              :key="gender"
            >{{ gender }}, </span>
          </template>
          <template v-slot:[`item.budget`]="{ item }">
            {{item.budget | formatNumber }}
          </template>
          <!-- <template v-slot:[`item.campaign_status`]="{ item }">
            <v-chip
              v-if="item.campaign_status === 0"
              color="warning"
              small
              outlined
            >
              <v-icon
                small
                left
              >mdi-alert-circle-outline</v-icon> Draft
            </v-chip>
            <v-chip
              v-if="item.campaign_status === 1"
              color="success"
              small
              outlined
            >
              <v-icon
                small
                left
              >mdi-progress-clock</v-icon> Progress
            </v-chip>
            <v-chip
              v-if="item.campaign_status === 2"
              color="error"
              small
              outlined
            >
              <v-icon
                small
                left
              >mdi-close-circle-outline</v-icon> Cancelled
            </v-chip>
            <v-chip
              v-if="item.campaign_status === 4"
              color="primary"
              small
              outlined
            >
              <v-icon
                small
                left
              >mdi-check-circle-outline</v-icon> Completed
            </v-chip>
          </template> -->
          <template v-slot:[`item.add_time`]="{ item }">
            {{item.add_time | dateFormat }}
          </template>
        </v-data-table>
        <div
          class="text-center ma-8"
          v-if="campList.length <= 0 && !loadingCam"
        >
          <img
            src="@/assets/images/no-campaign.png"
            width="150"
          />
          <h3>No Campaigns Found</h3>
          <v-btn
            depressed
            dark
            large
            color="primary"
            to="/campaign/create"
            style="width: 350px;"
          >Create your First Campaign</v-btn>
        </div>
        <div
          class="d-flex align-center justify-center pb-2"
          v-if="campList.length > 0"
        >
          <v-btn
            depressed
            dark
            large
            @click="submitSelectedCampaign"
            color="primary"
            :loading="loadingCam"
            style="width: 252px;"
          >Assign Campaigns</v-btn>
        </div>
        <v-pagination
          class="mt-2"
          v-model="assignCamp.page"
          :length="this.totalCampPages"
          @input="paginationCamp()"
          :total-visible="10"
          v-if="!loadingCam && totalCampPages > 1"
        ></v-pagination>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getFavouriteList, favDelete, submitSelectCampaign, influAssignCampList } from '@/api/influencer'
import constantData from '@/utils/constant'

export default {
  data () {
    return {
      tab: 0,
      ytCategory: constantData.ytCategory,
      dialogCampaign: false,
      selected: [],
      multipleSelection: [],
      loading: false,
      infId: null,
      loadingCam: false,
      favList: [],
      campList: [],
      favCount: 0,
      totalCampPages: 0,
      params: {
        type: 1,
        page: 1,
        size: 10
      },
      assignCamp: {
        type: null,
        page: 1,
        size: 10,
        influencerId: null
      },
      headers: [
        'selected',
        { text: 'Campaign Name', value: 'campaign_name', align: 'center' },
        { text: 'Campaign Type', value: 'campaign_type', align: 'center' },
        { text: 'Content Type', value: 'content_type', align: 'center' },
        { text: 'Category', value: 'category', align: 'center' },
        { text: 'Language', value: 'language', align: 'center' },
        { text: 'Gender', value: 'gender', align: 'center' },
        { text: 'Budget', value: 'budget', align: 'center' },
        { text: 'Admin Approval', value: 'status', align: 'center' },
        // { text: 'Campaign Status', value: 'campaign_status', align: 'center' },
        { text: 'Add Time', value: 'add_time', align: 'center' }
      ]
    }
  },
  mounted () {
    this.getFavList()
  },
  computed: {
    indexedItems () {
      return this.campList.map((item, index) => ({
        id: index,
        ...item
      }))
    }
  },
  methods: {
    catName (dataValue) {
      const newvalue = dataValue.split(',')
      var newcat = []
      for (let i = 0; i < newvalue.length; i++) {
        var cat = this.ytCategory.filter(function (obj) {
          return obj.value === newvalue[i]
        }).map(function (obj) {
          return obj.label
        })
        newcat = newcat.concat(cat)
      }
      if (!newcat.length) {
        return 'NA'
      } else {
        return newcat.toString()
      }
    },
    // alldata (selected) {
    //   if (selected.value === true) {
    //     this.multipleSelection = selected.items.map(item => { return item.campaign_id })
    //   } else {
    //     this.multipleSelection = []
    //   }
    // },
    selectData (selected) {
      const id = selected.item.campaign_id
      if (selected.value === true) {
        this.selected.push(selected.item)
        this.multipleSelection.push(id)
        this.multipleSelection = [...new Set(this.multipleSelection)]
      } else {
        if (selected.item.status === 2 || selected.item.status === 1) {
          this.$snackbar({
            message: `${selected.item.status === 2 ? 'Already Rejected' : 'Already Approved'}`,
            color: 'warning',
            timeout: 2000
          })
          this.selected.push(selected.item)
        } else {
          this.selected.splice(this.selected.findIndex(a => a.campaign_id === id), 1)
          const index = this.multipleSelection.indexOf(id)
          this.multipleSelection.splice(index, 1)
        }
      }
      this.selected = [...new Set(this.selected.map(item => item))]
    },
    async openDialogCampaign (influencerId) {
      this.infId = influencerId
      this.campList = []
      this.selected = []
      this.multipleSelection = []
      this.loadingCam = true
      this.dialogCampaign = true
      this.assignCamp.type = this.params.type
      this.assignCamp.page = 1
      this.assignCamp.influencerId = influencerId
      const data = await influAssignCampList(this.assignCamp)
      this.loadingCam = false
      if (data.success) {
        this.campList = data.campaigns.map(item => {
          item.category = item.category.split(',') || []
          item.language = item.language.split(',') || []
          item.gender = item.gender.split(',') || []
          return item
        })
        this.totalCampPages = Math.ceil(data.total_count / 10)
        this.selected = this.campList.filter((item, index) => item.assignCamp === '1')
        this.multipleSelection = this.selected.map(item => { return item.campaign_id })
      } else {
        this.$snackbar({
          message: data.message
        })
      }
    },
    async paginationCamp () {
      this.loadingCam = true
      const data = await influAssignCampList(this.assignCamp)
      this.loadingCam = false
      if (data.success) {
        this.campList = data.campaigns.map(item => {
          item.category = item.category.split(',') || []
          item.language = item.language.split(',') || []
          item.gender = item.gender.split(',') || []
          return item
        })
        this.totalCampPages = Math.ceil(data.total_count / 10)
        this.selected = this.campList.filter((item, index) => item.assignCamp === '1')
        this.multipleSelection = this.selected.map(item => { return item.campaign_id })
      } else {
        this.$snackbar({
          message: data.message
        })
      }
    },
    async submitSelectedCampaign () {
      // if (!this.multipleSelection.length) {
      //   this.$snackbar({
      //     color: 'error',
      //     timeout: 3000,
      //     message: 'Please select campaign first'
      //   })
      //   return
      // }
      const item = {
        assignData: this.multipleSelection,
        infId: this.infId,
        type: this.params.type,
        page: this.assignCamp.page,
        size: this.assignCamp.size
      }

      this.loadingCam = true
      const data = await submitSelectCampaign(item)
      if (data.success) {
        this.$snackbar({
          message: data.message
        })
        this.dialogCampaign = false
      } else {
        this.$snackbar({
          message: 'Something went wrong',
          color: 'error',
          timeout: 3000
        })
      }
      this.loadingCam = false
    },
    async favDelete (id) {
      this.loading = true
      const data = await favDelete({ id: id })
      this.loading = false
      if (data.success) {
        this.$snackbar({
          message: data.message
        })
        this.getFavList()
      } else {
        this.$snackbar({
          message: data.message,
          color: 'error',
          timeout: 5000
        })
      }
    },
    async getFavList () {
      this.loading = true
      this.favList = []
      this.params.type = this.tab === 0 ? 1 : 2
      const data = await getFavouriteList(this.params)
      if (data.success) {
        this.favList = data.list
        this.favCount = Math.ceil(data.total_count / 10)
      } else {
        this.$snackbar({
          message: data.message,
          color: 'error',
          timeout: 5000
        })
        this.favList = []
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  h4 {
    text-transform: uppercase;
    margin: 0;
  }
  .v-data-table >>> .v-data-table__wrapper > table {
    border-spacing: 0 12px !important;
  }
  .theme--light.v-data-table >>> .v-data-table__wrapper table th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    border: none !important;
    padding: 5px 6px;
  }
  .v-data-table >>> .v-data-table__wrapper > table > tbody > tr > td {
    font-weight: normal;
    font-size: 14px;
    line-height: normal;
    color: #333333;
    border: none !important;
    padding: 5px 6px;
  }
  .v-data-table >>> .v-data-table__wrapper > table > tbody > tr {
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.09);
    border-radius: 13px;
  }
  .v-data-table >>> tbody tr.v-data-table__selected {
    background: #e9ecfa;
  }
  .v-image {
    border-radius: 50%;
    height: 45px;
    width: 45px;
  }
  .v-icon {
    font-size: 24px;
  }
  .v-tabs {
    box-shadow: 0px 6px 6px rgb(0 0 0 / 4%);
  }
  h3 {
    font-weight: 500;
    font-size: 23px;
    line-height: 34px;
    color: #6b6b6b;
    margin: 20px 0;
  }
</style>
